import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional().nullable(),
  ngay_ct2: z.string().optional().nullable(),
  so_ct1: z.string().nullable(),
  so_ct2: z.string().nullable(),
  loai_du_lieu: z.string().nullable(),
  tl_yn: z.boolean(),

  ma_nvbh: z.string().nullable(),
  ma_kh: z.string().nullable(),
  nh_kh1: z.string().nullable(),
  nh_kh2: z.string().nullable(),
  nh_kh3: z.string().nullable(),
  rg_code: z.string().nullable(),
  mau_bc: z.number().nullable(),

  ma_gd: z.string().nullable(),
  dien_giai: z.string().nullable(),
  report_filtering: z.string().nullable(),
  data_analysis_struct: z.string().nullable()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  so_ct1: '',
  so_ct2: '',
  loai_du_lieu: '1',
  tl_yn: false,
  ma_nvbh: null,
  ma_kh: null,
  nh_kh1: null,
  nh_kh2: null,
  nh_kh3: null,
  rg_code: null,
  mau_bc: 20,

  ma_gd: null,
  dien_giai: '',
  report_filtering: '0',
  data_analysis_struct: '0'
};
